define(
    'connections/product-list-connection',[
        'jquery',

        'utils/ajax-util',

        'settings',
    ],

    function ($, ajax, settings) {
        /**
         * @class ProductListConnection
         */
        return (function () {

            /**
             * @constructor
             */
            function ProductListConnection() { }


            /**
             * When user selects/deselects filter checkbox, searches, loads more or changes order
             * 
             *
             * @param  {Object} data   - An object with input parameters: 
             *                        { 
             *                            offset: offset,           (Number) - nr of results to skip (already loaded)
             *                            q: query,                 (String) - search field words
             *                            categories: categories,   (String) - comma separated string of selected categories' id's
             *                            facets: facets,           (Object) - ex: { itemwebcolor: [Blue, Grey], productgender: [Men] }
             *                            orderBy: orderby,         (String) - ex: "Relevance"
             *                            outlet: outlet            (Bool)   - Is outlet productlisting.
             *                        }.
             * @return {Promise}       - A jQuery ajax promise.
             * 
             * @method getProductList
             * @returns new productListView.
             */
            ProductListConnection.prototype.getProductList = function (data) {
                return ajax.get(settings.productList, data);
            };

            ProductListConnection.prototype.getProductPriceView = function (productID) {
                return ajax.get(settings.productViewApiUrl + "/priceview" + '?id=' + productID);
            };

            return new ProductListConnection();
        })();
    }
);

